<template>
  <div class="about">
    <el-card v-for="section in sections" :key="section.id" class="about-section">
      <h2>{{ section.title }}</h2>
      <div class="section-content" v-html="formatContent(section.content)"></div>
    </el-card>
  </div>
</template>

<script>
import api from '../api'
import { marked } from 'marked'

export default {
  name: 'AboutPage',
  data() {
    return {
      sections: []
    }
  },
  mounted() {
    this.loadSections()
  },
  methods: {
    async loadSections() {
      try {
        const response = await api.get('/about/sections/')
        // 兼容分页和非分页响应
        if (Array.isArray(response.data)) {
          this.sections = response.data
        } else if (response.data.results) {
          this.sections = response.data.results
        } else {
          this.sections = []
        }
      } catch (error) {
        console.error('加载关于内容失败:', error)
        this.sections = []
      }
    },
    formatContent(content) {
      if (!content) return ''
      try {
        return marked(content)
      } catch (e) {
        return content.replace(/\n/g, '<br>')
      }
    }
  }
}
</script>

<style scoped>
.about {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.about-section {
  margin-bottom: 0;
  flex-shrink: 0;
  min-height: 0;
  overflow: hidden;
}

.about-section h2 {
  margin-bottom: 20px;
  color: #e0e0e0;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.section-content {
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.8);
  word-wrap: break-word;
  overflow-wrap: break-word;
  overflow: hidden;
  max-width: 100%;
}

.section-content :deep(h1),
.section-content :deep(h2),
.section-content :deep(h3) {
  margin-top: 20px;
  margin-bottom: 10px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.section-content :deep(p) {
  margin-bottom: 10px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.section-content :deep(img) {
  max-width: 100%;
  height: auto;
  display: block;
}

.section-content :deep(a) {
  color: #00d4ff;
  text-decoration: none;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.section-content :deep(a:hover) {
  text-decoration: underline;
}

.section-content :deep(pre) {
  max-width: 100%;
  overflow-x: auto;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.section-content :deep(code) {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.section-content :deep(table) {
  max-width: 100%;
  overflow-x: auto;
  display: block;
}

.section-content :deep(ul),
.section-content :deep(ol) {
  word-wrap: break-word;
  overflow-wrap: break-word;
  padding-left: 20px;
}
</style>

